<div class="sub-container">
  <div class="search d-flex">
    <app-table-search (filterChanged)="onFilterChanged($event)"></app-table-search>
    <app-buttons
      *ngIf="userRole == 'Admin'"
      [name]="btnName"
      [buttonType]="btnMatFlat"
      [buttonStyle]="btnStyleFilledSmall"
      (buttonClickEvent)="openInviteDialog()"
    >
      ></app-buttons
    >
  </div>
</div>
<div class="tabs-container">
  <mat-tab-group (selectedIndexChange)="onTabChange($event)" [(selectedIndex)]="currentTabIndex">
    <mat-tab *ngIf="userRole == 'Admin'" label="{{ managedUser }}" i18n></mat-tab>
    <mat-tab *ngIf="userRole == 'Admin'" label="{{ pendingApprovals }}" i18n></mat-tab>
    <mat-tab label="{{ groupManagement }}" i18n></mat-tab>
  </mat-tab-group>
</div>

<div class="content-container">
  <router-outlet (activate)="onChildActivate($event)"></router-outlet>
</div>
